module.exports = __webpack_public_path__ + "assets/images/aa0626a0cc1ec55bc779ecbe41733582.png";